// LEGACY CODE
import ItemHeaderAsync from '@automator/builder/_legacy/js/item/button-schedule';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-action-quick-delay' )
export class AutomatorBuilderItemActionQuickDelay extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// The item code. e.g. VIEWPAGE
	@property( { type: String, attribute: 'item-code' } ) accessor code;

	// The integration code. e.g. WP
	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	// eslint-disable-next-line require-jsdoc
	render() {
		// Create "Schedule" button
		const scheduleButton = new ItemHeaderAsync(
			'action',
			this.integrationCode,
			this.itemCode,
			this.itemID
		);

		// Check if we have to add the button
		if ( scheduleButton.shouldAddButton() ) {
			// Add the button
			return html`${ scheduleButton.$button }`;
		}
	}
}
